import { render, staticRenderFns } from "./ChristmasCanvas.vue?vue&type=template&id=2af15585&scoped=true&"
import script from "./ChristmasCanvas.vue?vue&type=script&lang=js&"
export * from "./ChristmasCanvas.vue?vue&type=script&lang=js&"
import style0 from "./ChristmasCanvas.vue?vue&type=style&index=0&id=2af15585&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af15585",
  null
  
)

export default component.exports